import { render } from "./ViewDetailsModal.vue?vue&type=template&id=48ea15a1"
import script from "./ViewDetailsModal.vue?vue&type=script&lang=js"
export * from "./ViewDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__